import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin); 

function ScrollToTopRoute({ history }) {

    useEffect(() => {
        const unlisten = history.listen(() => {
            gsap.to(window, {duration: 0.5, scrollTo: 0 });
        });
        return () => {
            unlisten();
        }
    }, []);

    return (null);
}

export default withRouter(ScrollToTopRoute);


// WEBPACK FOOTER //
// ./src/components/ScrollToTopRoute/ScrollToTopRoute.js